import type { PropsWithChildren } from 'react';
import { useTranslations } from 'next-intl';

export const ThreadWrapper = ({
  children,
  contributionsCount,
}: PropsWithChildren<{
  contributionsCount: number;
}>) => {
  const t = useTranslations('DISCUSSION');

  return (
    <section data-testid="discussion">
      <h3 className="vp-title-s announcement__comments__title">
        {t('COMMENT', {
          count: contributionsCount,
        })}
      </h3>
      {children}
    </section>
  );
};
